import { isSpacestPartnerListing } from './externalRedirect';

function normalizeCityKey(location) {
  if (!location || typeof location !== 'string') return '';
  return location
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function listingMatchesCity(listing, cityKey) {
  if (!cityKey) return true;
  const haystack = [
    listing.propertyLocation,
    listing.city,
    listing.propertyNeighborhood,
    listing.title,
  ]
    .filter(Boolean)
    .map(normalizeCityKey)
    .join(' ');
  return haystack.includes(cityKey) || normalizeCityKey(listing.propertyLocation) === cityKey;
}

/**
 * Top Spacest listings from current search (orden del listado = boost/interleave del backend).
 */
export function pickSpacestRecommendations(searchResults, { city = '', limit = 3 } = {}) {
  const list = Array.isArray(searchResults) ? searchResults : [];
  const cityKey = normalizeCityKey(city);

  let spacest = list.filter((item) => isSpacestPartnerListing(item));
  if (cityKey) {
    const inCity = spacest.filter((item) => listingMatchesCity(item, cityKey));
    if (inCity.length > 0) spacest = inCity;
  }

  return spacest.slice(0, Math.max(1, limit));
}

export function getListingCardImage(listing) {
  const img = listing?.images?.[0] || listing?.imageUrl || listing?.thumbnail;
  return typeof img === 'string' && img.trim() ? img.trim() : null;
}

export function getListingCardPrice(listing) {
  const n = Number(listing?.priceFrom ?? listing?.propertyPrice ?? listing?.minPrice);
  return Number.isFinite(n) && n > 0 ? n : null;
}
